module.exports = __webpack_public_path__ + "img/textzeile-schliessen.8b8dd005.svg";